import Anthropic from '@anthropic-ai/sdk';
import { ANTHROPIC_API_KEY } from '../../../../config';

const client = new Anthropic({
    apiKey: ANTHROPIC_API_KEY,
    dangerouslyAllowBrowser: true,
});

const JSON_FORMAT_SUFFIX = `
Tu DOIS répondre uniquement en JSON brut. Pas de markdown, pas de blocs de code, pas de texte supplémentaire. Utilise exactement ce format :
{
  "message": "Ta réponse conversationnelle ici",
  "options": ["Option 1", "Option 2", "Option 3", "Option 4"]
}
Fournis toujours entre 4 et 6 options pour que l'utilisateur puisse choisir.
Les options doivent être des réponses naturelles que l'utilisateur pourrait dire.
Garde les options concises (moins de 15 mots chacune).
Tu DOIS répondre en français.`;

const SYSTEM_PROMPTS = {
    news: `Tu es un partenaire de conversation amical qui discute de l'actualité et des événements récents.
Pose des questions engageantes et partage des perspectives intéressantes sur les événements mondiaux, la politique, la technologie, la science et la culture.
Garde la conversation accessible et équilibrée.` + JSON_FORMAT_SUFFIX,

    entertainment: `Tu es un partenaire de conversation enthousiaste qui discute de films, musique, séries, livres et culture populaire.
Partage des recommandations, discute des favoris et explore les sujets de divertissement avec un intérêt sincère.
Garde la conversation amusante et engageante.` + JSON_FORMAT_SUFFIX,

    medical: `Tu es un partenaire de conversation bienveillant et informatif qui discute de sujets de santé et de bien-être.
Couvre le bien-être général, la forme physique, la nutrition, la santé mentale et les bonnes habitudes.
Rappelle toujours que tu n'es pas médecin et suggère de consulter des professionnels pour des conseils médicaux spécifiques.` + JSON_FORMAT_SUFFIX,

    discussion: `Tu es un compagnon de conversation chaleureux et amical, prêt à discuter de tout.
Sois curieux, bienveillant et engageant. Suis les sujets proposés par l'utilisateur.
Garde la conversation naturelle et agréable.` + JSON_FORMAT_SUFFIX,
};

const STARTER_MESSAGES = {
    news: "Parlons de l'actualité",
    entertainment: "Parlons de films, musique et séries",
    medical: "Parlons de santé et bien-être",
    discussion: "Discutons de tout et de rien",
};

/**
 * Send a message to the Anthropic API and get a response with options.
 * @param {Array<{role: string, content: string}>} messages - Conversation history
 * @param {string} topic - Topic key for system prompt selection
 * @param {string} [userContext] - Optional user context to personalize the conversation
 * @returns {Promise<{message: string, options: string[]}>}
 */
export async function sendMessage(messages, topic, userContext) {
    let system = SYSTEM_PROMPTS[topic];
    if (userContext) {
        system += `\n\nContexte de l'utilisateur (utilise-le pour personnaliser la conversation) : ${userContext}`;
    }

    const response = await client.messages.create({
        model: 'claude-sonnet-4-5-20250929',
        max_tokens: 1024,
        system,
        messages,
    });

    let text = response.content[0].text.trim();
    // Strip markdown code fences if present
    text = text.replace(/^```(?:json)?\s*\n?/, '').replace(/\n?```\s*$/, '');
    const parsed = JSON.parse(text);
    return {
        message: parsed.message,
        options: parsed.options,
    };
}

export { STARTER_MESSAGES };
